import { useMemo } from 'react';

import { useLanguages } from '@/shared/hooks';

import { TRANSCRIPTOR_LANGUAGE } from '../config';

const LOCALE_TO_TRANSCRIPTOR_MAP: Record<string, string> = {
  'en-US': TRANSCRIPTOR_LANGUAGE.English,
  de: TRANSCRIPTOR_LANGUAGE.German,
  es: TRANSCRIPTOR_LANGUAGE.Spanish,
  fr: TRANSCRIPTOR_LANGUAGE.French,
  he: TRANSCRIPTOR_LANGUAGE.Hebrew,
  hu: TRANSCRIPTOR_LANGUAGE.Hungarian,
  it: TRANSCRIPTOR_LANGUAGE.Italian,
  ka: TRANSCRIPTOR_LANGUAGE.Georgian,
  kk: TRANSCRIPTOR_LANGUAGE.Kazakh,
  pl: TRANSCRIPTOR_LANGUAGE.Polish,
  pt: TRANSCRIPTOR_LANGUAGE.Portuguese,
  ro: TRANSCRIPTOR_LANGUAGE.Romanian,
  ru: TRANSCRIPTOR_LANGUAGE.Russian,
  uk: TRANSCRIPTOR_LANGUAGE.Ukrainian,
};

export const useTranscriptorLanguages = () => {
  const { languageOptions } = useLanguages();

  const transcriptorLanguageOptions = useMemo(() => {
    return languageOptions
      .filter((option) => LOCALE_TO_TRANSCRIPTOR_MAP[option.value])
      .map((option) => ({
        ...option,
        label:
          typeof option.label === 'string' && option.label.length > 0
            ? `${option.label.charAt(0).toUpperCase()}${option.label.slice(1)}`
            : option.label,
        value: LOCALE_TO_TRANSCRIPTOR_MAP[option.value],
      }));
  }, [languageOptions]);

  return {
    languageOptions: transcriptorLanguageOptions,
    isLoading: languageOptions.length === 0,
  };
};
